import { Col, Row, Carousel, CarouselProps } from "antd";
import slide1 from "src/shared/assets/images/landing/quote-slide-1.png";
import quoteS from "src/shared/assets/images/landing/quote-start.png";
import quoteE from "src/shared/assets/images/landing/quote-end.png";
import rightSlide from "src/shared/assets/images/landing/right-slide.png";
import leftSlide from "src/shared/assets/images/landing/left-slide.png";

import "./quote.less";
import { useRef } from "react";

const LQuote = () => {
  const ref: any = useRef();
  const settings: CarouselProps = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    draggable: true,
    // nextArrow: <img className="nextArrow" src={rightSlide} />,
    // prevArrow: <img className="prevArrow" src={rightSlide} />,
    // customPaging: (i: any) => (
    //   <div
    //     style={{
    //       width: "30px",
    //       color: "blue",
    //       border: "1px blue solid",
    //     }}
    //   >
    //     {i + 1}
    //   </div>
    // ),
  };
  return (
    <section id="quote">
      <Row justify="center" align="middle" className="row_quote">
        <Col span={24}>
          <h3>حرف ما را قبول نکنید!</h3>
          <p>
            روزانه هزاران کاربر خوشحال دارد که با ما کار می کنند .ما در حال کمک
            به مشاغل موجود در اینستاگرام
          </p>
        </Col>
        <Col xs={24} md={20}>
          <Row justify="space-around">
            <Col xs={0} md={3} style={{ position: "relative" }}>
              <img
                src={quoteS}
                style={{ position: "absolute", bottom: "2px", left: "35px" }}
              />
              <img
                src={rightSlide}
                className="rightSlide"
                onClick={() => ref?.current?.next()}
              />
            </Col>
            <Col xs={23} md={18} className="sliders-col">
              <Carousel {...settings} ref={ref as any}>
                <div className="slide-div">
                  <img src={slide1} />
                </div>
                <div className="slide-div">
                  <img src={slide1} />
                </div>
                <div className="slide-div">
                  <img src={slide1} />
                </div>
              </Carousel>
            </Col>
            <Col xs={0} md={3}>
              <img
                src={quoteE}
                style={{ position: "absolute", top: "2px", right: "35px" }}
              />
              <img
                src={leftSlide}
                className="leftSlide"
                onClick={() => ref?.current?.prev()}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LQuote;
